global.SearchHelper = function (searchText, type) {

    this.setLastSearchMeta = function () {
        if (process.client && this.searchText && this.matchType) {
            customSessionStorage.setItem('lastSearchText', this.searchText);
            customSessionStorage.setItem('lastSearchType', this.matchType);
        }
    };

    this.searchText = searchText;
    this.type = type;
    this.matchType = '';
    this.searchRequestParams = {};
    this.searchTextShow = '';
    this.filterIcon = '';
    this.searchTags = [];

    if (this.searchText.match(/@/)) {
        this.matchType = 'email';
        this.searchRequestParams = { email: this.searchText };
        this.filterIcon = 'fa fa-envelope';
    } else if (this.searchText.match(/^[0-9 \+\-]+$/g)) {
        this.matchType = 'phone';
        this.searchRequestParams = { phone: this.searchText };
        this.filterIcon = 'fa fa-phone';
    } else {
        this.matchType = 'name';
        this.searchRequestParams = { raw_name: this.searchText };
        this.filterIcon = 'fa fa-user';
    }

    this.searchTextShow = this.searchText;
    this.searchTags.push(this.searchTextShow);
    this.searchRequestParams.lang = global.selectedLang;

    this.setLastSearchMeta();
};


//////////////////
// WEBPACK FOOTER
// ./plugins/search_helper.js
// module id = ./plugins/search_helper.js
// module chunks = 54